import { AjaxBasics, CustomRegulars } from '@mamba/clients';
import lodash from 'lodash';
import queryString from 'query-string';
import Vue from 'vue';
import { DotKey } from './dotkey';
import { link } from './extension';
import { $AppConfig } from './global';
import { Static } from './static';
import { Store } from './store';
lodash.set(Vue, '$onLoginOut', async () => {
    await $AppConfig.onClear();
    await Store.System.onLoginOut();
    window.location.href = window.location.origin;
});
Object.defineProperty(Vue.prototype, '$onLoginOut', {
    get: lodash.constant(Vue.$onLoginOut),
});
Object.defineProperty(Vue.prototype, '$Static', {
    get: lodash.constant(Static),
});
// 创建 页面地址 转换参数
Object.defineProperty(Vue.prototype, '$CreatePageUrl', {
    get: lodash.constant((url, query) => {
        url = AjaxBasics.queryParamsToUrl(url, query);
        url = queryString.stringifyUrl({
            url,
            query: lodash.pickBy(query, lodash.identity),
        });
        return url;
    }),
});
Object.defineProperty(Vue.prototype, '$FilterSpecial', {
    get: lodash.constant((value) => {
        let initValue = '';
        if (lodash.isString(value)) {
            initValue = value;
        }
        else {
            initValue = value.target.value;
        }
        try {
            initValue = initValue
                .replace(CustomRegulars.special_characters, '')
                .trim()
                .replace(/\s+/g, ' ');
            return initValue;
        }
        catch (err) {
            return value;
        }
    }),
});
// 外链
Object.defineProperty(Vue.prototype, '$Link', {
    get: () => link,
});
Object.defineProperty(Vue.prototype, '$DotKey', {
    get: lodash.constant(DotKey),
});
